import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { ImageFile } from 'components/mediaLibrary/images/ImageFile';
import { IState } from 'reducers/reducers';
import { loadImage } from 'actions/MediaActions';
import { ObjectId } from '@visikon/core-models/base';

interface Props {
  imageId: ObjectId;
  className?: string;
}

/**
 * This is a connected ImageFileWrapper which loads an Image Object from an ID.
 */
export function ImageFileWrapper(props: Props) {
  const dispatch = useDispatch();
  const { language, image } = useSelector((state: IState) => ({
    language: state.language.activeLanguage,
    image: (state.media.imagesByFolder.root || []).find((img) => img._id === props.imageId),
  }));

  useEffect(() => {
    dispatch(loadImage(props.imageId));
  }, [dispatch, props.imageId]);

  if (!image) return null;

  return <ImageFile className={props.className} image={image} language={language} />;
}
